export default {
  GET_LIST_NEWS: "/WebsiteSTNHD/NewsList",
  GET_NEWS_DETAILS: "/WebsiteSTNHD/NewsDetail"
}
